import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { PurchaseOrders_ShellService, EModalSize, EToasterType, EToasterPosition } from './PurchaseOrders.shell.service';
import { PurchaseOrders_OperationService } from './PurchaseOrders.operation.service';
import { PurchaseOrders_DatasourceService } from './PurchaseOrders.datasource.index';
import { PurchaseOrders_FlowService } from './PurchaseOrders.flow.index';
import { PurchaseOrders_ReportService } from './PurchaseOrders.report.index';
import { PurchaseOrders_LocalizationService } from './PurchaseOrders.localization.service';
import { Language } from './localization.service';
import { $types } from './PurchaseOrders.types'

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'PurchaseOrders-owners_dd_single',
  templateUrl: './PurchaseOrders.owners_dd_single.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PurchaseOrders_owners_dd_singleComponent),
      multi: true
    }
  ]
})
export class PurchaseOrders_owners_dd_singleComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;
  
  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return false;
  }

  get isSingle() {
    return true;
  }


  inParams: { statusId?: number, projectId?: number } = { statusId: null, projectId: null };
  @Input('statusId') set $inParams_statusId(value: any) {
    this.inParams['statusId'] = value;
  }
  get $inParams_statusId(): any {
    return this.inParams['statusId'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }

  fullTextSearch: string;

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: PurchaseOrders_ShellService,
    private datasources: PurchaseOrders_DatasourceService,
    private flows: PurchaseOrders_FlowService,
    private reports: PurchaseOrders_ReportService,
    private localization: PurchaseOrders_LocalizationService,
    private operations: PurchaseOrders_OperationService,
    private _elementRef: ElementRef
    ) {
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  
  $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): number | number[] {
    return this._innerValue;
  }

  set value(val: number | number[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }



  displayWithFn(value: any): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {

      const $selector = this;
      const $utils = this.utils;

      this.fullTextSearch = null;
      const $fullTextSearch = null;
      this.datasources.PurchaseOrders.ds_owners_dd.getByKeys({
        $keys: [value],
        statusId:  1 ,
        projectId:  $selector.inParams.projectId ,
        fullTextSearch:  encodeURIComponent($selector.fullTextSearch) ,
      }).then(result => {
        const found = result.result[0];
        const e: { Id?: number, LookupCode?: string, Name?: string } = found ?? {};
        const $option = { entity: e };
         const $entity = e;
        const displayTextResult = found ? ($option.entity.LookupCode === $option.entity.Name ? $option.entity.LookupCode :  $option.entity.LookupCode + ' ' + $option.entity.Name) : 'No data to display';
        this.displayTextChange.emit(displayTextResult);
        resolve(displayTextResult);
      });

    });
    return promise;
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {

    const promise = new Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }>((resolve, reject) => {

      const $selector = this;
      const $utils = this.utils;

      this.fullTextSearch = filterText;
      const $fullTextSearch = filterText;
      this.datasources.PurchaseOrders.ds_owners_dd.getList({
        $top: 15,
        $skip: 0,
        statusId:  1 ,
        projectId:  $selector.inParams.projectId ,
        fullTextSearch:  encodeURIComponent($selector.fullTextSearch) ,
      }).then(result => {
        resolve({
          list: result.result.map(item => {
            const $option = { entity: item };
            const $entity = item;
            const $resultOption = { key: null, name: $option.entity.LookupCode === $option.entity.Name ? $option.entity.LookupCode :  $option.entity.LookupCode + ' ' + $option.entity.Name, disabled: null };
            $resultOption.key = $option.entity.Id;
            return $resultOption;
          }),
          totalCount: result.totalCount,
          top: 15
        });
      });

    });

    return promise;

  }

}
